"use client";

export default function ArticleWrapperClient({ children }) {
    return <>{children}</>;
}
